import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'promo-expired',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './promo-expired.component.html',
  styleUrl: './promo-expired.component.scss'
})
export class PromoExpiredComponent {

}
